module.exports = __webpack_public_path__ + "img/rosemount-705-wireless-totalizing-transmitter-wireless-transmitter.5761279b.png";